import React, { useState, useEffect } from "react";
import MobilePlansList from "./components/MobilePlanList";
import logo from '../../assets/logo.png';
import s from "./mobile.module.css";
import {instance, production} from "../../API/API";
import moment from "moment/moment";
import {message} from "antd";

const GeneralMobile = ({ user, exit }) => {
    const [loading, setLoading] = useState(true);
    const [plans, setPlans] = useState([]);
    const [objects, setObjects] = useState([]);
    const [staff, setStaff] = useState([]);
    const [reportsTemp, setReportsTemp] = useState([]);
    const [reports, setReports] = useState([]);
    const [photoLinks, setPhotoLinks] = useState([]);
    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        let end = moment().endOf('day').format('X')
        let start = moment().startOf('day').format('X')
        try {
            const objects_for_reports_req = await instance.get(`reports/get_objects_for_report.php`);
            if (objects_for_reports_req.data.objects && objects_for_reports_req.data) {
                setObjects(objects_for_reports_req.data.objects);
            }
            const work_templates_req = await instance.get(`reports/get_works_template.php`);
            if (work_templates_req.data.template && work_templates_req.data) {
                setReportsTemp(work_templates_req.data.template);
            }
            const staff_req = await instance.get(`reports/get_staff.php`);
            if (staff_req.data.staff && staff_req.data) {
                setStaff(staff_req.data.staff);
            }
            const reports_req = await instance.get(`reports/get_reports.php?start=${start}&end=${end}`);
            if (reports_req.data.reports && reports_req.data) {
                setReports(reports_req.data.reports);
            }
            const photo_req = await instance.get(`reports/get_photo_by_time.php?start=${start}&end=${end}`);
            if (photo_req.data.reports && photo_req.data) {
                setPhotoLinks(photo_req.data.links);
            }
            const plans_req = await instance.get(`reports/get_plans.php?type=current`);
            if (plans_req.data.plans && plans_req.data) {
                setPlans(plans_req.data.plans);
            }


        } catch (e) {
            console.log(e.message);
        } finally {
            setLoading(false);
        }
    }
    async function post_report(reportData) {
        try {
            const formData = new FormData();

            Object.keys(reportData).forEach(key => {
                formData.append(key, reportData[key]);
            });

            // Добавляем флаг обновления
            formData.append('updateFlag', reportData.updateFlag ? '1' : '0');

            if (reportData.report_id) {
                formData.append('report_id', reportData.report_id);
            }

            const response = await instance.post(
                `/reports/post_report.php`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                    withCredentials: true, // для отправки кук авторизации
                    timeout: 30000, // 30 секунд таймаут
                }
            );

            const result = response.data;

            if (result.success) {
                message.success(reportData.updateFlag ? 'Отчет обновлен' : 'Отчет отправлен');
                // Обновляем данные после отправки
                loadData();
            } else {
                throw new Error(result.error || 'Ошибка сервера');
            }

            return result;
        } catch (error) {
            console.error('Ошибка отправки отчета:', error);
            throw error;
        }
    }

    return (
        <div className={s.main}>
            <div className={s.status}>
                <div className={s.header}>Garden Design APP</div>
                <div className={s.status_line}>
                    <div className={s.status__label}>{`Login as: ${user.login}`}</div>
                    <div className={`${s.status__exit} ${s.pointer}`} onClick={exit}>Выход</div>
                </div>
            </div>

            <div className={s.mobcontent}>
                {loading ? (
                    <div className={s.imgcontainer}>
                        <img className={s.logo} src={logo} alt="Logo" />
                    </div>
                ) : (
                    <MobilePlansList
                        plans={plans}
                        objects={objects}
                        staff={staff}
                        reportsTemp={reportsTemp}
                        reports={reports}
                        photoLinks={photoLinks}
                        oldreports={reports}
                        onSubmit={post_report}
                        user={user}
                    />
                )}
            </div>


            <div className={s.mobfooter}>
                Garden Design @ {new Date().getFullYear()}
            </div>
        </div>
    );
};

export default GeneralMobile;